var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "51.000000pt",
    height: "49.000000pt",
    viewBox: "0 0 51.000000 49.000000",
    preserveAspectRatio: "xMidYMid meet",
    fill: "current",
    stroke: "current",
    strokeWidth: "current",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,49.000000) scale(0.100000,-0.100000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M210 416 c-31 -69 -35 -74 -69 -80 -20 -3 -50 -6 -68 -6 -80 0 -83 -29 -8 -94 61 -52 63 -60 41 -144 -25 -92 -9 -101 81 -47 32 19 64 35 72 35 7 0 40 -16 73 -36 89 -54 102 -39 73 81 -12 50 -12 62 -1 70 26 20 93 83 100 94 14 22 -15 41 -63 42 -90 3 -100 8 -128 74 -46 109 -59 111 -103 11z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.16d6c6e50d41979f7f7a9b0e3729fe1f.svg";
export { ForwardRef as ReactComponent };